import { GeolocationState } from '@/contexts/geolocation-context';
import { ListCompaniesParams } from '@/types/dto/ListCompaniesParams.dto';

const ITEMS_PER_PAGE = 20;

interface BuildCompaniesQueryParams {
  appliedRadius: number;
  geo: Pick<GeolocationState, 'granted' | 'lat' | 'lng'>;
  page: number;
  search: string;
  selectedCity: string | null;
}

export function buildCompaniesQuery({
  appliedRadius,
  geo,
  page,
  search,
  selectedCity,
}: BuildCompaniesQueryParams): ListCompaniesParams {
  const query: ListCompaniesParams = {
    skip: (page - 1) * ITEMS_PER_PAGE,
    take: ITEMS_PER_PAGE,
  };

  if (search) {
    query.search = search;
  }

  if (selectedCity) {
    query.cityId = selectedCity;

    return query;
  }

  if (geo.granted && typeof geo.lat === 'number' && typeof geo.lng === 'number') {
    query.latitude = geo.lat;
    query.longitude = geo.lng;
    query.radius = appliedRadius;
  }

  return query;
}

export { ITEMS_PER_PAGE };
